module.exports = "## Image Converter\r\n\r\nNeed to convert png to jpg or jpg to png? Our image editor allows you to convert your images to any of the following file types; jpg, png. If you are looking for something more advanced, this [image converter](https://www.freeconvert.com/image-converter) supports conversion of almost all image formats. "


//////////////////
// WEBPACK FOOTER
// ./src/containers/ImageResize/image-converter.md
// module id = 1176
// module chunks = 0